import { Switch } from "@mui/material";
import React from "react";

// material-table title: whose orders these are + the "My Branch Orders"
// toggle. Inline (not absolutely positioned) so it wraps instead of sliding
// under the search box on narrow screens.
const WDCustomTitle = (props) => {
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-1 py-1">
      <div className="truncate text-base font-semibold">{props.name}</div>
      <label className="inline-flex cursor-pointer items-center">
        <Switch
          checked={props.branchOrders}
          onChange={() => {
            props.setLoading(true);
            props.setBranchOrders(!props.branchOrders);
          }}
        />
        <p className="app-muted text-xs font-medium">My Branch Orders</p>
      </label>
    </div>
  );
};

export default WDCustomTitle;
